import { ScrollArea } from "@/components/ui/scroll-area";
import { TESTIDS } from "@/constants/testIds";

function fmtCoord([r, c], rows = 4) {
  if (rows === 2) {
    const row = r === 0 ? "B" : "A";
    return `${row}.${c + 1}`;
  }
  const row = r === 0 ? "B-outer" : r === 1 ? "B-inner" : r === 2 ? "A-inner" : "A-outer";
  return `${row}.${c + 1}`;
}

function eventLine(e, rows) {
  switch (e.type) {
    case "TURN_STARTED":
      return `Turn ${e.turn}: ${e.player === "A" ? "Player 1" : "Player 2"} begins.`;
    case "PIT_SELECTED":
      return `Selected ${fmtCoord(e.from, rows)} (${e.count} counters).`;
    case "COUNTERS_PICKED_UP":
      return `Picked up ${e.count} from ${fmtCoord(e.from, rows)}.`;
    case "COUNTER_SOWN":
      return `Sowed 1 into ${fmtCoord(e.to, rows)}.`;
    case "SOWING_COMPLETE":
      return `Sowing landed at ${fmtCoord(e.landing, rows)}${e.relays ? ` after ${e.relays} relay${e.relays === 1 ? "" : "s"}` : ""}.`;
    case "RELAY_STARTED":
      return `Relay: pick up ${e.count} from ${fmtCoord(e.at, rows)}.`;
    case "CAPTURE_TRIGGERED":
      return e.column != null ? `Capture triggered in column ${e.column + 1}.` : `Capture triggered at ${fmtCoord(e.at, rows)}.`;
    case "COUNTERS_CAPTURED":
      return `Captured ${e.count} from ${fmtCoord(e.from, rows)}.`;
    case "FREE_CAPTURE":
      return `Free pit captured: ${e.count} from ${fmtCoord(e.from, rows)}.`;
    case "GRAND_SLAM_CANCELLED":
      return `Grand-slam capture cancelled.`;
    case "REMAINING_SEEDS_AWARDED":
      return e.to ? `Remaining seeds awarded to ${e.to === "A" ? "Player 1" : "Player 2"} (${e.count}).`
                 : `Remaining seeds awarded (A:${e.A ?? 0}, B:${e.B ?? 0}).`;
    case "ADDITIONAL_CAPTURE_OWED":
      return `Capturer owed ${e.allowance} more pit${e.allowance === 1 ? "" : "s"}.`;
    case "ADDITIONAL_CAPTURES_TAKEN":
      return `Additional captures taken (total ${e.total}).`;
    case "TURN_ENDED":
      return `Turn ended. ${e.captured ? `Captured ${e.captured}.` : "No capture."}${e.relays ? ` (${e.relays} relay${e.relays === 1 ? "" : "s"})` : ""}`;
    case "PHASE_CHANGED":
      return `Phase → ${e.phase} for ${e.player === "A" ? "Player 1" : "Player 2"}.`;
    case "NO_LEGAL_MOVE":
      return `${e.player === "A" ? "Player 1" : "Player 2"} has no legal move.`;
    case "GAME_WON":
      return `Game over: ${e.player === "A" ? "Player 1" : "Player 2"} wins (${e.reason || ""}).`;
    case "GAME_DRAWN":
      return `Game drawn (${e.reason || ""}).`;
    default:
      return e.type;
  }
}

export function EventLog({ state }) {
  const lines = (state.history || []).flatMap((h) => h.events || []);
  const rows = state.board?.length || 4;
  return (
    <div data-testid={TESTIDS.eventLog} className="bg-muted/40 rounded-xl border border-border/60">
      <p className="text-xs uppercase tracking-widest text-muted-foreground px-4 py-2 border-b border-border/60">
        Event log
      </p>
      <ScrollArea className="h-64 px-4 py-2">
        {lines.length === 0 ? (
          <p className="text-sm text-muted-foreground italic">No events yet.</p>
        ) : (
          <ol className="space-y-1 font-mono text-xs leading-relaxed">
            {lines.map((e, i) => (
              <li key={i} className="text-foreground/80">
                <span className="text-muted-foreground mr-2">{String(i + 1).padStart(3, "0")}</span>
                {eventLine(e, rows)}
              </li>
            ))}
          </ol>
        )}
      </ScrollArea>
    </div>
  );
}
